// extracted by mini-css-extract-plugin
module.exports = {"footer":"_139b9cbc","footerRow":"_3deb9396"};